import React from 'react';
import { Shuffle, Package, TrendingUp, Clock, Shield } from 'lucide-react';
import { whyThisWorks, marketingImages } from '../../data/mock';

const iconMap = {
  0: Shuffle,
  1: Package,
  2: TrendingUp,
  3: Clock,
  4: Shield
};

const WhyThisWorks = () => {
  return (
    <section className="py-24 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Why This Strategy Works
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            A proven approach to building sustainable, diversified income
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Content */}
          <div className="space-y-6">
            {whyThisWorks.map((item, idx) => {
              const IconComponent = iconMap[idx];
              return (
                <div key={idx} className="flex gap-4">
                  <div className="w-12 h-12 rounded-xl bg-teal-500/20 flex items-center justify-center flex-shrink-0">
                    <IconComponent className="w-6 h-6 text-teal-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                    <p className="text-gray-400 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Image */}
          <div className="flex justify-center">
            <img 
              src={marketingImages.multiDevice} 
              alt="Multi-device access"
              className="w-full max-w-md rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyThisWorks;
